const countries: { [key: string]: { flag: string, name: string } } = {
  'fr-FR': {
    flag: '/assets/flags/france.svg',
    name: 'Français'
  },
  'en-US': {
    flag: '/assets/flags/uk.svg',
    name: 'English'
  }
}

const convertCountryToLocale = (country: string): string => {
  const countryMap: { [key: string]: string } = {
    fr: 'fr-FR',
    en: 'en-US'
  }
  return countryMap[country] || 'en-US'
}
export { countries, convertCountryToLocale }
